import v4 from "uuid/v4";

const GenerateUuid = () => {
  return v4();
};

export default GenerateUuid;
